import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DropdownModule,
  ],
})
export class DropdownComponent extends CommonBaseComponent {
  @Input() placeholder: string = 'SELECT';
  @Input() selectedItem: any;

  constructor() {
    super();
  }

  getLabelByValue(value: string | number) {
    return this.item?.options?.find((i: any) => i.value === value)?.label || '';
  }
}
